var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20px/copy_link_300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.54804 14.5836C7.17293 14.5836 6.85587 14.4541 6.59685 14.1951C6.33783 13.936 6.20831 13.619 6.20831 13.2439V3.75674C6.20831 3.38163 6.33783 3.06456 6.59685 2.80553C6.85587 2.54651 7.17293 2.41699 7.54804 2.41699H15.0352C15.4103 2.41699 15.7273 2.54651 15.9864 2.80553C16.2454 3.06456 16.3749 3.38163 16.3749 3.75674V13.2439C16.3749 13.619 16.2454 13.936 15.9864 14.1951C15.7273 14.4541 15.4103 14.5836 15.0352 14.5836H7.54804ZM7.54804 13.5003H15.0352C15.0993 13.5003 15.158 13.4736 15.2115 13.4202C15.2649 13.3667 15.2916 13.308 15.2916 13.2439V3.75674C15.2916 3.69263 15.2649 3.63386 15.2115 3.58043C15.158 3.52701 15.0993 3.50031 15.0352 3.50031H7.54804C7.48393 3.50031 7.42517 3.52701 7.37175 3.58043C7.31832 3.63386 7.2916 3.69263 7.2916 3.75674V13.2439C7.2916 13.308 7.31832 13.3667 7.37175 13.4202C7.42517 13.4736 7.48393 13.5003 7.54804 13.5003ZM4.96473 17.1669C4.58963 17.1669 4.27257 17.0374 4.01354 16.7784C3.75451 16.5193 3.625 16.2023 3.625 15.8272V5.25674H4.70831V15.8272C4.70831 15.8913 4.73502 15.9501 4.78844 16.0035C4.84187 16.0569 4.90063 16.0836 4.96473 16.0836H13.5352V17.1669H4.96473Z",
    fill: "#007AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copyLink.3d4f58cfe19071d1bd8bddfcea447bf2.svg";
export { ForwardRef as ReactComponent };